<!--
 * @Author: your name
 * @Date: 2022-05-30 15
-->
<!-- 保养手册 -->
<template>
  <div class="max-maintain">
    <div class="content">
      <!-- 内容 -->
      <div class="select-row">
        <!-- 筛选列表 -->
        <div class="filtrate-list">
          <!-- 系列 -->
          <div class="series">
            <el-tabs v-model="seriesAct">
              <el-tab-pane :disabled="idx== 0" v-for="(item,idx) in modelSeriesList" :key="idx" :label="item.class_name"
                           :name="item.class_id">
                <!-- 型号 -->
                <div class="model-number">
                  <el-tabs v-model="modelActive" @tab-click="handleClick">
                    <el-tab-pane :disabled="idx== 0" v-for="(item,idx) in item.class_list" :key="idx"
                                 :label="item.pro_name" :name="item.lead_product_id"></el-tab-pane>
                  </el-tabs>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- 手册 -->
          <div class="download">
            <el-tabs v-model="downActive" @tab-click="downloadClick">
              <el-tab-pane :disabled="idx === 0" v-for="(item,idx) in downloadList" :key="idx" :label="item.label" :name="item.label"/>
            </el-tabs>
          </div>
        </div>
        <!-- 图片详情 -->
        <div v-if="imgLIst.length>0">
          <div class="upkeep">
            <div
              v-for="(item,index) in imgLIst"
              :key="index"
              @click="showVideoClick(item)"
              class="upkeep-content animate__animated animate__zoomIn"
              :class="(index-1)%3 == 0 ? 'upkeep-content-margin' : '' "
            >
              <div class="upkeep-img"><img :src="item.preview" alt=""></div>
              <div class="upkeep-name">{{ item.title }}</div>
            </div>
          </div>
          <!-- 查看更多 -->
          <examine-more v-if="moreShow" @examine="examine" :moreLoading='moreLoading'></examine-more>
        </div>
        <el-empty v-else description="暂无数据"></el-empty>
        <el-dialog :visible.sync="dialogTableVisible" @close="closeVideo">
          <video :src="videoUrl" class="topvideo" controls autoplay muted width="100%"></video>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { maintainListApi, maintainSlectApi } from '../../../../request/api'
import SecondTitle from '@/components/SecondTitle'
import examineMore from '@/components/examineMore'

export default {
  components: {
    SecondTitle,
    examineMore,
  },
  data() {
    return {
      page: 1,
      page_size: 9,
      moreLoading: false,
      moreShow: true,
      videoUrl: '',
      fileUrl: '',
      seriesAct: '2',
      modelActive: '3',
      downActive: '维修视频',
      dialogTableVisible: false,
      imgLIst: [],
      // 车型
      modelSeriesList: [
        { id: 0, class_name: '车型选择' },
      ],
      // 型号
      modelNumberList: [
        { id: 0, pro_name: '型号选择' },
      ],
      downloadList: [
        { id: 0, label: '车型选择' },
        { id: 2, label: '手册下载' },
      ],
      selectActive: '0',
      numberActive: '0',
      serveActive: 2,
    }
  },
  created() {
    this.maintainSlectApi()
  },
  methods: {
    // 条件选择列表数据
    maintainSlectApi() {
      const params = {
        m: 'Mobile',
        c: 'MajorProduct',
        a: 'production_class_list',
        lang: 1,
      }
      maintainSlectApi(params).then(({ data }) => {
        data.datas.info.forEach((item, idx) => {
          let arr = ([...this.modelNumberList, ...item.class_list])
          item.class_list = arr
          this.modelSeriesList.push(item)
        })
        this.seriesAct = this.modelSeriesList[1].class_id
        this.modelActive = this.modelSeriesList[1].class_list[1].lead_product_id
        this.maintainListApi()
      })

    },
    // 列表数据
    maintainListApi() {
      const params = {
        m: 'Mobile',
        c: 'Article',
        a: 'get_all_news_list',
        lang: 1,
        type: 9,
        class_id: this.seriesAct,
        id: this.modelActive,
        page: this.page,
        page_size: this.page_size,
      }
      maintainListApi(params).then(({ data }) => {
        this.moreLoading = false
        if (data.datas.info.length > 0) {
          this.fileUrl = data.datas.info[0].file_url
        } else {
          this.fileUrl = ''
        }
        if (this.page === 1) {
          this.imgLIst = data.datas.info
        } else {
          data.datas.info.forEach((item, idx) => {
            if (this.page * this.page_size <= data.datas.count) {
              this.imgLIst.push(item)
            }
            if (this.page * this.page_size > data.datas.count) {
              this.imgLIst.push(item)
              this.moreShow = false
            }
          })
        }
      })
    },
    // 点击系列
    handleClick(val) {
      this.moreLoading = true
      this.maintainListApi()
    },
    // 点击下载手册
    downloadClick(evt) {
      if (this.fileUrl){
        window.open(this.fileUrl)
      }else {
        this.$message.info("暂无手册")
      }
    },
    // 查看更多
    examine() {
      this.page++
      this.maintainListApi()
      this.moreLoading = true
    },
    // 打开视频弹窗
    showVideoClick(val) {
      this.videoUrl = val.video_path
      this.dialogTableVisible = true
    },
    // 关闭弹窗
    closeVideo() {
      this.videoUrl = ''
    },
  },
}
</script>
<style lang="scss">
.max-maintain {
  // max-width: 1920px;
  width: 100%;
  margin: 0 auto;
}

.banner {
  width: 100%;
  height: 500px;

  .bannerImg {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.content {
  width: 100%;

  .el-dialog {
    background: none;
    box-shadow: none;
  }

  .select-row {
    width: 1336px;
    margin: 0 auto;
    // margin-top: 35px;
    .select-type {
      height: 39px;
      text-align: center;
      width: 100%;
      display: flex;
      line-height: 39px;

      .select-type-title {
        width: 103px;
        height: 100%;
        background: #C6C6C6;
        border-right: 1px solid #ffffff;
      }

      .select-list {
        width: 1207px;
        padding-left: 26px;
        height: 100%;
        background: #C6C6C6;
        display: flex;

        .list-details {
          margin-right: 75px;
          cursor: pointer;
          font-size: 14px;
        }

        .select-active {
          font-size: 16px !important;
          color: #FFF101;
          font-weight: 700;
        }
      }
    }

    .select-num {
      border-top: 1px solid #ffffff;

      .list-details {
        margin-right: 86px !important;
      }

      .number-active {
        font-size: 16px !important;
        color: #FFF101;
        font-weight: 700;
      }
    }

    .upkeep {
      width: 1336px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .upkeep-content-margin {
        margin: 0 38px;
      }

      .upkeep-content {
        width: 420px;
        margin-top: 60px;
        height: 334px;
        transition: 0.5s;
        cursor: pointer;

        .upkeep-img {
          width: 370px;
          margin: 0 auto;
          height: 222px;
          padding-top: 22px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .upkeep-name {
          font-size: 18px;
          font-weight: 700;
          margin-top: 30px;
          // margin-left: 13px;
          text-align: center;
        }

        .text-group {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          bottom: 190px;
          opacity: 0;
          // transition: 0.5s;
          .downloadtext, .videotext {
            margin-bottom: 15px;
            width: 140px;
            height: 38px;
            border: 1px solid;
            text-align: center;
            line-height: 2.3;
            font-size: 16px;
          }
        }
      }

      .upkeep-content:hover {
        .text-group {
          opacity: 1;
        }

        background: #5a5a5a;
        width: 420px;
        height: 334px;

        .upkeep-name {
          color: #eec20a;
        }

        .text {
          margin-bottom: 15px;
          width: 140px;
          height: 38px;
          border: 1px solid #eec20a;
          color: #ffffff;
          text-align: center;
          line-height: 2.3;

          .el-icon-right {
            margin-left: 10px;
          }

          .upkee-border {
            width: 0px;
            height: 38px;
            position: relative;
            top: -37px;
            background-color: #eec20a;
          }

        }

        .text:hover {
          .text-1 {
            position: relative;
            z-index: 1;
            color: #000000;
          }

          .upkee-border {
            width: 140px;
            transition: width 1s;
          }
        }
      }
    }

    .filtrate-list {
      margin-top: 50px;

      .series, .model-number, .download {
        .el-tabs__header {
          margin-bottom: 2px;
        }

        .el-tabs__nav {
          justify-content: flex-start;
          width: 100%;
        }

        .el-tabs__item {
          color: #5a5a5a;
        }

        .el-tabs__item:nth-child(3) {
          border-left: 1px solid white;

        }

        .el-tabs__item:nth-child(2) {
          cursor: default;

          &:hover {
            color: #5a5a5a;
            font-weight: 400;
          }
        }

        .el-tabs__item:not(:nth-child(2)) {
          width: 180px;
        }

        .el-tabs__nav-scroll {
          background-color: #cccccc79;
        }

      }

      .download {
        .el-tabs__item:nth-child(2) {
          opacity: 0;
        }
      }
    }
  }
}

.navigationTow {
  width: 100%;
  height: 45px;
  background: rgba(248, 203, 19, .8);
  display: flex;
  justify-content: center;
  align-items: center;

  .item {
    margin: 0 132px;
    cursor: pointer;
    color: #ffffff;
    font-size: 14px;
  }

  .itemActive {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/serve/maintain/maintain.vue